import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutDrsSettleHist extends Layout {
    sourceDrsSettleHist: DataSource;
    tableDrsHist: Table;
}
